import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { PortService } from '../port.service';
import { TableLazyLoadEvent } from 'primeng/table';
import { TableAction, TableColumn } from 'src/app/shared/models/table-config.model';

@Component({
  selector: 'app-port-list-modal',
  templateUrl: './port-list-modal.component.html',
  standalone: false
})
export class PortListModalComponent implements OnInit {
  ports: any[] = [];
  allPorts: any[] = [];
  totalItems = 0;
  loading = true;
  filter = '';

  tableColumns: TableColumn[] = [
    { field: 'id', header: 'ID', type: 'text', width: '15%' },
    { field: 'acronym', header: 'ACRONYM', type: 'text', width: '20%' },
    { field: 'name', header: 'NAME', type: 'text', width: 'auto' },
    { field: 'actions', header: '', type: 'actions', width: '15%' }
  ];

  tableActions: TableAction[] = [
    {
      label: 'Select',
      styleClass: 'p-button-outlined p-button-secondary font-bold h-8 text-xs',
      command: (row) => this.ref.close({ port: row })
    }
  ];

  constructor(public ref: DynamicDialogRef, private portService: PortService) {}

  ngOnInit() { this.loadAll(); }

  loadAll() {
    this.loading = true;
    this.portService.getPorts(1000, 0, '').subscribe({
      next: (data: any) => {
        this.allPorts = data.ports || [];
        this.totalItems = this.allPorts.length;
        this.processData({ first: 0, rows: 10 });
      },
      error: () => this.loading = false
    });
  }

  loadLazy(event: TableLazyLoadEvent) {
    if (this.allPorts.length) this.processData(event);
  }

  processData(event: TableLazyLoadEvent) {
    this.loading = true;
    let processed = [...this.allPorts];
    if (this.filter) {
      const lower = this.filter.toLowerCase();
      processed = processed.filter(p =>
        p.name?.toLowerCase().includes(lower) ||
        p.acronym?.toLowerCase().includes(lower)
      );
    }
    this.totalItems = processed.length;
    const first = event.first || 0;
    this.ports = processed.slice(first, first + (event.rows || 10));
    setTimeout(() => this.loading = false, 100);
  }

  handleSearch(val: string) {
    this.filter = val;
    this.processData({ first: 0, rows: 10 });
  }

  closeModal() { this.ref.close(); }
}
